export const GET_PETS = 'GET_PETS';
export const GET_PETS_LOADING = 'GET_PETS_LOADING';
export const GET_PETS_ERROR = 'GET_PETS_ERROR';

export const GET_PETS_BY_ID_CUSTOMER = 'GET_PETS_BY_ID_CUSTOMER';
export const GET_PETS_BY_ID_CUSTOMER_LOADING = 'GET_PETS_BY_ID_CUSTOMER_LOADING';
export const GET_PETS_BY_ID_CUSTOMER_ERROR = 'GET_PETS_BY_ID_CUSTOMER_ERROR';

export const GET_PETS_BY_ID = 'GET_PETS_BY_ID';
export const GET_PETS_BY_ID_LOADING = 'GET_PETS_BY_ID_LOADING';
export const GET_PETS_BY_ID_ERROR = 'GET_PETS_BY_ID_ERROR';